import { Button, Card, Tab, Tabs } from '@mui/material';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import { useMemo, useState } from 'react';
import { FaFileExcel, FaX } from 'react-icons/fa6';
import ArticlesTablePreview from './articlesTablePreview/ArticlesTablePreview';
import FormatsTablePreview from './articlesTablePreview/FormatsTablePreview';
import ProvidersFormatsTablePreview from './articlesTablePreview/ProvidersFormatsTablePreview';
import useCreateMassiveArticles from './articlesTablePreview/useCreateMassiveArticles';
import IssuesPopover from './articlesTablePreview/IssuesPopover';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useNavigate } from 'react-router-dom';
const LoadedDataFormExcel = ({ dataExcel, setDataExcel, setFileName, fileName }) => {
  const [tabValue, setTabValue] = useState('resumen');
  const { data, mutateAsync, isLoading } = useCreateMassiveArticles();
  const navigate = useNavigate();
  const closeModal = () => {
    navigate(`../`);
  };

  const isDisabled = useMemo(() => {
    let isDisabled = false;
    // Si esta cargando
    if (isLoading) isDisabled = true;
    // Si ya se ha llevado a cabo
    if (data) isDisabled = true;
    // Si no hay data que guardar
    if (
      dataExcel?.newArticles.length === 0 &&
      dataExcel?.editedArticles.length === 0 &&
      dataExcel?.newFormats.length === 0 &&
      dataExcel?.editedFormats.length === 0 &&
      dataExcel?.newProvidersFormats.length === 0 &&
      dataExcel?.editedProvidersFormats.length === 0
    )
      isDisabled = true;

    if (
      [
        ...dataExcel?.withIssuesArticles.flatMap((i) =>
          i.issues.map((issue) => `[${i.excelSheet} - Fila ${i.excelRow}] ${issue}`),
        ),
        ...dataExcel?.withIssuesFormats.flatMap((i) =>
          i.issues.map((issue) => `[${i.excelSheet} - Fila ${i.excelRow}] ${issue}`),
        ),
        ...dataExcel?.withIssuesProvidersFormats.flatMap((i) =>
          i.issues.map((issue) => `[${i.excelSheet} - Fila ${i.excelRow}] ${issue}`),
        ),
      ].length > 0
    )
      isDisabled = true;
    return isDisabled;
  }, [dataExcel, isLoading, data]);

  return (
    <div className="articles-excel-content">
      <Tabs value={tabValue} onChange={(event, newValue) => setTabValue(newValue)} aria-label="tabla-excel">
        <Tab className="tabs-navigate-admin" label="Resumen" value="resumen" />
        <Tab
          className="tabs-navigate-admin"
          value="articulos"
          label={
            <span style={{ display: 'flex', alignItems: 'center', gap: '0.3rem' }}>
              Articulos
              {dataExcel?.withIssuesArticles?.length > 0 && (
                <ReportProblemOutlinedIcon style={{ color: '#c50202', width: '1rem', height: '1rem' }} />
              )}
            </span>
          }
        />
        <Tab
          className="tabs-navigate-admin"
          value="formatos"
          label={
            <span style={{ display: 'flex', alignItems: 'center', gap: '0.3rem' }}>
              Formatos
              {dataExcel?.withIssuesFormats?.length > 0 && (
                <ReportProblemOutlinedIcon style={{ color: '#c50202', width: '1rem', height: '1rem' }} />
              )}
            </span>
          }
        />
        <Tab
          className="tabs-navigate-admin"
          value="proveedores"
          label={
            <span style={{ display: 'flex', alignItems: 'center', gap: '0.3rem' }}>
              Proveedores
              {dataExcel?.withIssuesProvidersFormats?.length > 0 && (
                <ReportProblemOutlinedIcon style={{ color: '#c50202', width: '1rem', height: '1rem' }} />
              )}
            </span>
          }
        />
      </Tabs>

      {tabValue === 'resumen' && (
        <>
          <div>
            <Button
              size="small"
              variant="outlined"
              color="success"
              startIcon={<FaFileExcel />}
              endIcon={<FaX size="10" color="#cc0e17" />}
              disabled={isLoading}
              onClick={() => {
                setDataExcel(null);
                setFileName(null);
              }}
            >
              {fileName}
            </Button>
          </div>

          <p className="info">Se han obtenido los siguientes datos de excel proporcionado.</p>

          <div className="articles-excel-cards-container">
            <Card className="articles-excel-card">
              <h1 className={dataExcel.newArticles.length !== 0 ? 'created' : ''}>{dataExcel.newArticles.length}</h1>
              <span>nuevos articulos</span>
            </Card>
            <Card className="articles-excel-card">
              <h1 className={dataExcel.editedArticles.length !== 0 ? 'edited' : ''}>
                {dataExcel.editedArticles.length}
              </h1>
              <span>Articulos editados</span>
            </Card>
            <Card className="articles-excel-card">
              <h1>{dataExcel.withOutChangesArticles.length}</h1>
              <span>Articulos sin cambios</span>
            </Card>
            <Card className="articles-excel-card">
              <h1 className={dataExcel.newFormats.length !== 0 ? 'created' : ''}>{dataExcel.newFormats.length}</h1>
              <span>Nuevos formatos</span>
            </Card>
            <Card className="articles-excel-card">
              <h1 className={dataExcel.editedFormats.length !== 0 ? 'edited' : ''}>{dataExcel.editedFormats.length}</h1>
              <span>Formatos editados</span>
            </Card>
            <Card className="articles-excel-card">
              <h1>{dataExcel.withOutChangesFormats.length}</h1>
              <span>Formatos sin cambios</span>
            </Card>
            <Card className="articles-excel-card">
              <h1 className={dataExcel.newProvidersFormats.length !== 0 ? 'created' : ''}>
                {dataExcel.newProvidersFormats.length}
              </h1>
              <span>Nuevos Proveedores</span>
            </Card>
            <Card className="articles-excel-card">
              <h1 className={dataExcel.editedProvidersFormats.length !== 0 ? 'edited' : ''}>
                {dataExcel.editedProvidersFormats.length}
              </h1>
              <span>Proveedores editados</span>
            </Card>
            <Card className="articles-excel-card">
              <h1>{dataExcel.withOutChangesProvidersFormats.length}</h1>
              <span>Proveedores sin cambios</span>
            </Card>
          </div>
        </>
      )}

      {tabValue === 'articulos' && (
        <ArticlesTablePreview
          newArticles={dataExcel?.newArticles ?? []}
          editedArticles={dataExcel?.editedArticles ?? []}
          withOutChangesArticles={dataExcel?.withOutChangesArticles ?? []}
          withIssuesArticles={dataExcel?.withIssuesArticles ?? []}
        />
      )}
      {tabValue === 'formatos' && (
        <FormatsTablePreview
          articles={[...dataExcel?.newArticles, ...dataExcel?.editedArticles, ...dataExcel?.withOutChangesArticles]}
          newFormats={dataExcel?.newFormats ?? []}
          editedFormats={dataExcel?.editedFormats ?? []}
          withOutChangesFormats={dataExcel?.withOutChangesFormats ?? []}
          withIssuesFormats={dataExcel?.withIssuesFormats ?? []}
        />
      )}
      {tabValue === 'proveedores' && (
        <ProvidersFormatsTablePreview
          articles={[...dataExcel?.newArticles, ...dataExcel?.editedArticles, ...dataExcel?.withOutChangesArticles]}
          newProvidersFormats={dataExcel?.newProvidersFormats ?? []}
          editedProvidersFormats={dataExcel?.editedProvidersFormats ?? []}
          withOutChangesProvidersFormats={dataExcel?.withOutChangesProvidersFormats ?? []}
          withIssuesProvidersFormats={dataExcel?.withIssuesProvidersFormats ?? []}
        />
      )}
      {console.log('DATA', data)}
      <div
        style={{
          display: 'flex',
          gap: '2rem',
        }}
      >
        {!data ? (
          <>
            <Button
              size="small"
              variant="contained"
              disabled={isDisabled}
              onClick={async () => {
                if (!dataExcel) return;

                await mutateAsync({
                  newArticles: dataExcel?.newArticles ?? [],
                  editedArticles: dataExcel?.editedArticles ?? [],
                  withOutChangesArticles: dataExcel?.withOutChangesArticles ?? [],

                  newFormats: dataExcel?.newFormats ?? [],
                  editedFormats: dataExcel?.editedFormats ?? [],
                  withOutChangesFormats: dataExcel?.withOutChangesFormats ?? [],

                  newProvidersFormats: dataExcel?.newProvidersFormats ?? [],
                  editedProvidersFormats: dataExcel?.editedProvidersFormats ?? [],
                  withOutChangesProvidersFormats: dataExcel?.withOutChangesProvidersFormats ?? [],
                });
              }}
            >
              Confirmar y guardar
            </Button>

            {[
              ...dataExcel?.withIssuesArticles.flatMap((i) => i.issues),
              ...dataExcel?.withIssuesFormats.flatMap((i) => i.issues),
              ...dataExcel?.withIssuesProvidersFormats.flatMap((i) => i.issues),
            ].length > 0 && (
              <IssuesPopover
                issues={[
                  ...dataExcel?.withIssuesArticles.flatMap((i) =>
                    i.issues.map((issue) => ({
                      message: `[${i.excelSheet} - Fila ${i.excelRow}] ${issue?.message ?? issue}`,
                      field: issue?.field,
                    })),
                  ),
                  ...dataExcel?.withIssuesFormats.flatMap((i) =>
                    i.issues.map((issue) => ({
                      message: `[${i.excelSheet} - Fila ${i.excelRow}] ${issue?.message ?? issue}`,
                      field: issue?.field,
                    })),
                  ),
                  ...dataExcel?.withIssuesProvidersFormats.flatMap((i) =>
                    i.issues.map((issue) => ({
                      message: `[${i.excelSheet} - Fila ${i.excelRow}] ${issue?.message ?? issue}`,
                      field: issue?.field,
                    })),
                  ),
                ]}
              />
            )}
          </>
        ) : (
          <div
            style={{
              display: 'flex',
              gap: '0.5rem',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <span style={{ display: 'flex', gap: '1rem', alignItems: 'center', color: '#0b991e' }}>
              Se han guardado los cambios con exito
              <CheckCircleIcon />
            </span>
            <Button variant="contained" onClick={() => closeModal()}>
              Cerrar
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default LoadedDataFormExcel;
